export enum SystemStatusCategoryEnum {
    MONITORED = 'monitored',
    UNMONITORED_SITES = 'unmonitored_sites',
    EXCLUDED_SITES = 'excluded_sites'
}
